<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-1 cw-100">
        <i class="fa fa-question-circle text-warning fa-1x"></i>
      </div>
      <div class="col-md-11" style="text-align: justify;">
        <div [innerHTML]="body | translate"></div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success mw-80" (click)="yes()">
      <i class="fas fa-thumbs-up"></i> {{ "LABEL.YES" | translate }} </button>
    <button type="button" class="btn btn-outline-danger mw-80" (click)="no()">
      <i class="fa fa-times-circle"></i> No
    </button>
  </div>
</div>
